import { createContext } from 'react';
import { tEventBubbleContext } from './EventBubble.types.ts';

const initialState: tEventBubbleContext = {
  isHovered: false,
  setIsHovered: () => {},
  showMenu: false,
  setShowMenu: () => {},
  menuRef: { current: null },
  replyMessages: [],
  setReplyMessages: () => {},
  isReplying: false,
  setIsReplying: () => {},
};

export const EventBubbleContext =
  createContext<tEventBubbleContext>(initialState);
